export default {"src":"/_next/static/media/facebook-logo-hover.23cbd26a.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};